module.exports = __webpack_public_path__ + "img/mobileReplace.09d7c5c8.svg";